import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const hideSticky = pathname.startsWith("/apply");
  return (
    <div className="min-h-screen bg-[#030A14] text-white antialiased">
      <Nav />
      <main className="pt-16 md:pt-20">{children}</main>
      <Footer />

      {/* Sticky Apply Now — mobile only (nav already shows CTA on desktop) */}
      {!hideSticky && (
        <div className="lg:hidden fixed bottom-4 inset-x-4 z-40" data-testid="sticky-apply-wrap">
          <Link to="/apply" data-testid="sticky-apply-now"
            className="ef-btn-primary rounded-full h-12 flex items-center justify-center text-sm font-medium shadow-2xl">
            Apply Now <ArrowRight className="h-4 w-4 ml-2" />
          </Link>
        </div>
      )}
    </div>
  );
}

